(function () {
    const customSelectTrigger = document.querySelector('.store-selector-mobile .custom-select-trigger');
    if(customSelectTrigger) {
      const customOptionsContainer = document.querySelector('.store-selector-mobile .custom-options');
      const customOptions = Array.from(document.querySelectorAll('.store-selector-mobile .custom-option'));
      const selectElement = document.querySelector('.store-selector-mobile .store-selector-actual');
  
      customSelectTrigger.addEventListener('click', function () {
          this.classList.toggle('open');
          customOptionsContainer.classList.toggle('open');
      });
  
      document.addEventListener('click', function (e) {
          if (!customSelectTrigger.contains(e.target)) {
              customSelectTrigger.classList.remove('open');
              customOptionsContainer.classList.remove('open');
          }
      });
  
      window.addEventListener('scroll', function () {
          customSelectTrigger.classList.remove('open');
          customOptionsContainer.classList.remove('open');
      });
    }
    
})();
